import { QueryResult, useQuery } from "@apollo/client";
import { orderBy } from "lodash";
import { GET_PROJECTS } from "graphql/queries";
import { Project } from "types";

export type ProjectResult = {
    getUserProjects: Project[];
};

export function useProjects(showGlobal?: boolean): [Project[], QueryResult<ProjectResult>] {
    const queryData = useQuery<ProjectResult>(GET_PROJECTS, {
        variables: { showGlobal: !!showGlobal },
        errorPolicy: "all"
    });
    const { data } = queryData;
    return [data ? orderBy(data.getUserProjects, (p: Project) => p.name) : [], queryData];
}
